module.exports = __webpack_public_path__ + "img/xxlj_icon_7.31fa6557.svg";